import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=26bb066c&scoped=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=js"
export * from "./NotificationCenter.vue?vue&type=script&lang=js"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=26bb066c&prod&scoped=true&lang=css"
import style1 from "./NotificationCenter.vue?vue&type=style&index=1&id=26bb066c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bb066c",
  null
  
)

export default component.exports